import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { NavigationOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import LogoutButton from '@/components/ui/logout-button';
import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import { ForbiddenJurisdictionOpeningNotificationButton, ForbiddenJurisdictionOpeningNotificationText } from './jurisdiction-opening-notification';

const ForbiddenJurisdiction = () => {
  const { t } = useTranslation();

  return (
    <>
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <NavigationOff />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle className="mb-8">{t('forbiddenJurisdiction.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('forbiddenJurisdiction.description')}</PageHeadingDescription>
        <PageHeadingDescription>
          <ForbiddenJurisdictionOpeningNotificationText />
        </PageHeadingDescription>
      </PageHeading>
      <footer className="flex flex-col gap-4">
        <ForbiddenJurisdictionOpeningNotificationButton />
        <Button size="lg" variant="outline" asChild>
          <a href={import.meta.env.VITE_APP_SUPPORT_NEW_REQUEST_URL}>{t('contactSupport')}</a>
        </Button>
        <LogoutButton size="lg" variant="outline" />
      </footer>
    </>
  );
};
ForbiddenJurisdiction.displayName = 'ForbiddenJurisdiction';

export default ForbiddenJurisdiction;
